module.exports = __webpack_public_path__ + "img/logo.4db60d72.png";